var _objectSpread = require("/app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var plugin = require('tailwindcss/plugin');
var baseStyles = {
  overflow: 'hidden',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical'
};
var lineClamp = plugin(function (_ref) {
  var matchUtilities = _ref.matchUtilities,
    addUtilities = _ref.addUtilities,
    theme = _ref.theme,
    variants = _ref.variants;
  var values = theme('lineClamp');
  matchUtilities({
    'line-clamp': function lineClamp(value) {
      return _objectSpread(_objectSpread({}, baseStyles), {}, {
        '-webkit-line-clamp': "".concat(value)
      });
    }
  }, {
    values: values
  });
  addUtilities([{
    '.line-clamp-none': {
      '-webkit-line-clamp': 'unset'
    }
  }], variants('lineClamp'));
}, {
  theme: {
    lineClamp: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6'
    }
  },
  variants: {
    lineClamp: ['responsive']
  }
});
module.exports = lineClamp;